// Module
var code = "<cjs-button ref=\"addTimeslot\"></cjs-button>\n<cjs-smart-table ref=\"timeslotsSmartTable\"></cjs-smart-table>";
// Exports
module.exports = code;